<template>
  <div id="address-information">
    <v-card id="v-card" v-if="StartupLoadingFlag">
      <v-container>
        <v-row wrap>
          <v-col cols="12" xl="6" md="6" sm="6" v-for="n in 4" :key="n">
            <br />
            <br />
            <v-skeleton-loader v-bind="attrs" type="paragraph"></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card elevation="4" outlined shaped v-if="!StartupLoadingFlag" id="v-card">
      <br />

      <v-row wrap>
        <v-col cols="9" lg="9">
          <h3 class="text-dark lg-ml-3 ml-3">
            <!-- <i id="app-bar-icon" class="fas fa-id-card-alt"></i>&nbsp;&nbsp; -->
            <b id="heading">Document Details</b>
            <small> (Click the Image to download)</small>
          </h3>
        </v-col>
      </v-row>

      <v-card-text style="padding-left: 1%; padding-right: 0%" id="card-text">
        <v-container class="py-0" v-if="tableData1.length > 0">
          <v-row wrap>
            <v-col
              cols="12"
              lg="4"
              md="6"
              sm="4"
              v-for="(item, index) in tableData1"
              :key="index"
            >
              <h5 align="center">Document - {{ index + 1 }}</h5>
              <v-card class="p-3" align="center">
                <v-row wrap class="mt-3">
                  <v-col cols="12" sm="12" md="12" lg="12">
                    <!-- <h5>Document Name</h5> -->
                    <h5 class="text-dark">
                      {{ item.DocumentName }}
                    </h5>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12">
                    <!-- <h5>Reference No</h5> -->
                    <h5 class="text-dark">
                      {{ item.ReferenceNo }}
                    </h5>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12">
                    <!-- <h5>Image</h5> -->
                    <a :href="item.ImagePath" target="_blank">
                      <img
                        style="padding: 5px"
                        width="90"
                        height="70"
                        :src="item.ImagePath"
                        :alt="item.DocumentName"
                        align="center"
                      />
                    </a>
                  </v-col>
                </v-row>
              </v-card>
              <!-- <v-card> -->
              <!-- <viewer rebuild :images="item.AllImages">
                  <img
                    style="padding: 5px"
                    width="60"
                    height="60"
                    :src="src"
                    :key="src"
                    :alt="item.DocumentName"
                    v-for="src in item.AllImages"
                  />
                </viewer>-->
              <!-- </v-card> -->
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import companyConfig from "@/company_config.json";
import common from "@/view/Common.vue";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},

  data() {
    return {
      StartupLoadingFlag: false,
      MemberId: 0,

      pageTitle: "Document details",
      pageDescription: "List of document details for age proof",

      DeleteLoadingFlag: false,

      SearchFlag: false,
      ResultFlag: false,

      selected: [],
      selectedData: {},
      search: "",

      FloatingButton: {},

      tableColumns1: [],
      tableOptions1: {
        FloatingButton: {},
      },
      tableData1: [],

      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");

      this.MemberId = this.$route.query.id;
      console.log("MemberId = ", this.MemberId);

      this.getTableRecords();
    },
    getTableRecords() {
      console.log("getTableRecords is called");

      // var validate1 = this.$refs.form2.validate();
      var validate1 = true;
      console.log("validate1=" + validate1);

      if (validate1) {
        this.SearchFlag = true;
        this.StartupLoadingFlag = true;
        this.ResultFlag = false;
        this.tableData1 = [];
        this.selected = [];
        this.selectedData = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members-document-details/show";
        var upload = {
          UserInterface: 1,
          MemberId: this.MemberId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;
            thisIns.StartupLoadingFlag = false;
            thisIns.ResultFlag = true;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            thisIns.tableOptions1 = records.TableOptions;
            thisIns.tableColumns1 = records.TableHeader;

            if (flag == 1) {
              // thisIns.toast("success", output);
              thisIns.tableData1 = records.TableData;
              console.log(thisIns.tableData1);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
            thisIns.StartupLoadingFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.sweetAlert("error", message, false);
      }
    },
  },
  mounted() {},
  beforeMount() {
    console.log("beforeMount called");

    var token = this.$session.get("token");
    token = token == (null || undefined) ? 0 : token;

    if (token == 0) {
      this.$router.push("/login");
    } else {
      this.UserFlag = true;
      this.refreshPageData();
    }
  },
};
</script>
